export default "__VITE_ASSET__cP1PlwIRSln8iiklOw2aSQ__"